const getAccountId = () => {
  const match = window.location.pathname.match(/\/app\/accounts\/(\d+)/);
  return match?.[1] || null;
};

const getAxiosClient = () => {
  if (!window.axios) {
    throw new Error(
      'El cliente Axios configurado por Chatwoot no está disponible'
    );
  }

  return window.axios;
};

const LiveCallsAPI = {
  get() {
    const accountId = getAccountId();

    if (!accountId) {
      return Promise.reject(
        new Error('No se pudo determinar la cuenta activa')
      );
    }

    return getAxiosClient().get(
      `/api/v1/accounts/${accountId}/smarttec/live_calls`
    );
  },
};

export default LiveCallsAPI;
